// TODO(20250401~): remove this after the promotion event is over, or refactor if it's still needed

import { Button as RawButton } from "@kobalte/core/button";
import { Show, Suspense, createSignal } from "solid-js";
import { Temporal } from "temporal-polyfill";
import { Dialog, DialogContent, DialogFooter } from "./ui/dialog";

import PromotionBanner from "~/assets/promotion-user-0331.png";
import { createToeQuery } from "~/lib/gql/createToeQuery";
import { graphql } from "~/lib/gql/tada";
import { latest } from "~/lib/latest";
import { Image } from "./ui/image";
import { Skeleton } from "./ui/skeleton";
import { WebLink } from "./webLink";

const HIDE_EVENT_BANNER_UNTIL_DATE_KEY = "backpac-event-banner-shown";
const NOW = Temporal.Now.zonedDateTimeISO("America/Los_Angeles");

class PromotionEventStatus {
  // valid until 2025-03-31
  public hasPromotionalEvent = (() => {
    return NOW.month < 4;
  })();

  public get isShowPopup() {
    if (!this.hasPromotionalEvent) return false;

    const storedDate = localStorage.getItem(HIDE_EVENT_BANNER_UNTIL_DATE_KEY);
    if (!storedDate) return true;

    try {
      const lastShownDate = Temporal.PlainDate.from(storedDate);
      const currentDate = NOW.toPlainDate();
      const daysSinceLastShown = currentDate.since(lastShownDate).days;
      return this.hasPromotionalEvent && daysSinceLastShown >= 7;
    } catch (e) {
      console.error(e);
      return true;
    }
  }

  public setPopupHidden() {
    localStorage.setItem(
      HIDE_EVENT_BANNER_UNTIL_DATE_KEY,
      Temporal.Now.zonedDateTimeISO("America/Los_Angeles").toPlainDate().toString(),
    );
  }
}

export const promotionEventStatus = new PromotionEventStatus();

const CheckUsingMusicQuery = graphql.persisted(
  "sha256:b553ab92508522e935285df2d3a5df03e946293a3f391941ecb4343d8918f756",
  graphql(
    `
			query PromotionEvent { 
				doesUseMusic
			}
		`,
  ),
);

const HELP_CENTER_ROOT_URL =
  "https://help.backpac.app/Early-User-Exclusive-80-Revenue-Share-16656f70dfd0805db42ae62e14fcf50c";

export const PromotionEventBanner = () => {
  const [query] = createToeQuery({
    query: CheckUsingMusicQuery,
  });

  return (
    <Show when={!(latest(() => query.data?.doesUseMusic) ?? true)}>
      <WebLink href={HELP_CENTER_ROOT_URL}>
        <div class="py-10px px-16px bg-[#DEF54F] flex gap-6px items-center">
          <i class="inline-block i-bp-info size-16px text-black" />
          <span class="prose-xs-b text-primary">Unlock an exclusive 80% revenue share!</span>
        </div>
      </WebLink>
    </Show>
  );
};

export const PromotionEventForActiveUserBanner = () => {
  const [query] = createToeQuery({
    query: CheckUsingMusicQuery,
  });

  return (
    <Show when={latest(() => query.data?.doesUseMusic ?? false)}>
      <WebLink href={HELP_CENTER_ROOT_URL}>
        <div class="py-10px px-16px bg-[#DEF54F] flex gap-6px items-center mt-4px rounded-6px">
          <i class="inline-block i-bp-info size-16px text-black" />
          <span class="prose-xs-b text-primary">80% revenue share applied (valid until 3/31)</span>
        </div>
      </WebLink>
    </Show>
  );
};

export const PromotionEventPopup = () => {
  const [isShowPopup, setIsShowPopup] = createSignal(promotionEventStatus.isShowPopup);

  return (
    <Dialog open={isShowPopup()}>
      <DialogContent class="p-0! gap-0! rounded-none!">
        <Suspense fallback={<Skeleton width="320px" height="380px" />}>
          <WebLink href={HELP_CENTER_ROOT_URL}>
            <Image src={PromotionBanner} alt="Promotion Banner" width={320} />
          </WebLink>
        </Suspense>
        <DialogFooter class="flex h-48px mt-0! flex-row! p-16px justify-between!">
          <RawButton
            class="flex items-center gap-4px"
            onClick={() => {
              promotionEventStatus.setPopupHidden();
              setIsShowPopup(false);
            }}
            tabIndex={-1}
          >
            <i class="inline-block i-bp-check size-12px" />
            <span class="prose-xs text-primary">Don't show again for 7 days</span>
          </RawButton>
          <RawButton
            class="flex items-center gap-4px focus-outline-none"
            onClick={() => {
              setIsShowPopup(false);
            }}
          >
            <span class="prose-xs text-primary">OK</span>
          </RawButton>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
